<template>
  <div class="breadcrumb">
    <template v-for="(item, index) in items">
      <span
        v-if="item.clickable"
        :key="`item-${index}`"
        class="breadcrumb-item clickable"
        @click="handleClick(item.action)"
      >
        {{ item.label }}
      </span>
      <span v-else :key="`item-${index}`" class="breadcrumb-item current">
        {{ item.label }}
      </span>
      <span
        v-if="index < items.length - 1"
        :key="`sep-${index}`"
        class="breadcrumb-separator"
      >
        >
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BreadcrumbNav',
  props: {
    items: {
      type: Array,
      default: () => [],
      validator(items) {
        return items.every(
          item =>
            typeof item === 'object' &&
            item.label &&
            typeof item.clickable === 'boolean'
        )
      }
    }
  },
  methods: {
    handleClick(action) {
      if (action) {
        this.$emit('breadcrumb-click', action)
      }
    }
  },
  emits: ['breadcrumb-click']
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-bottom: 10px;
  padding: 0px !important;
}

.breadcrumb-item {
  color: rgba(255, 255, 255, 0.7);

  &.clickable {
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: rgba(212, 175, 55, 0.8);
      text-decoration: underline;
    }
  }

  &.current {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
  }
}

.breadcrumb-separator {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

@media (max-width: 768px) {
  .breadcrumb {
    font-size: 13px;
    gap: 6px;
  }
}
</style>
